import { render, staticRenderFns } from "./TrendCard.vue?vue&type=template&id=581d8c5f"
import script from "./TrendCard.vue?vue&type=script&lang=js"
export * from "./TrendCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports